import { _form } from './_form';

export const challengesCreate = () => {
  _form();
};
